import 'core-js'
import 'raf/polyfill'

import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import TagManager from 'react-gtm-module'

import { GTM_ID, GTM_AUTH, GTM_PREVIEW } from './constants/environment'
import { buildNumber } from './version'

import store from './store'
import App from './App'

import './assets/css/styles.scss'

import 'react-app-polyfill/ie9'
import smoothscroll from 'smoothscroll-polyfill'
import { getPrivacityTerms, getCart, checkDates } from './storage'
smoothscroll.polyfill()

getPrivacityTerms(store.dispatch)
getCart(store.dispatch)
checkDates()

if (buildNumber !== '[version]') {
    console.log('Versão', buildNumber)
}

TagManager.initialize({
    gtmId: GTM_ID,
    auth: GTM_AUTH,
    preview: GTM_PREVIEW
})

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <App />
        </Router>
    </Provider>,
    document.getElementById('root')
)
